
import { Component, Vue, Prop } from 'vue-property-decorator';

import { OrderStage } from '@/types/reportOrder';
import eventBus from '@/utils/eventBus';
import { parseTime } from '@/utils';
import { UserModule } from '@/store/modules/user';
import {
  checkPermissionCompany
} from '@/utils/permission';
import { Type } from '@/types/permissionType';
import draggable from 'vuedraggable';
import SearchItem from './item.vue';
import dayjs from 'dayjs';

@Component({
  name: 'orderSearch',
  components: {
    draggable,
    SearchItem
  }
})
export default class extends Vue {
  @Prop({
    type: Number,
    default: OrderStage.UNDERWAY,
    validator: (value:any) => {
      return OrderStage[value] !== undefined;
    }
  })
  private stage!: OrderStage;

  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  private searchTaskStateVisibility!:boolean

  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  private all!: Boolean;

  private isToggle = false
  private checkList: any = []
  private searchArray: any = []
  private showSearchArray: any = []
  private orderForm: any = {
    number: '',
    // startTime: '',
    // endTime: '',
    dateTimeRange: '',
    person: '',
    servicer: '',
    armedState: '',
    numberWork: '',
    appointmentTime: '',
    customerDept: {},
    address: '',
    faultPhenomenon: {}
  }
  private isShowServicer=false;
  private isShowWorkOrderNum=false;
  private vipLev=0;
  private yyyy = 366;
  private yy = new Date().getFullYear();
  private mm = new Date().getMonth();
  private dd = new Date().getDate();

  private searchKey = ''
  private visiblePopover = false

  created() {
    if (UserModule.getCompany && UserModule.getCompany.vip_level) {
      this.vipLev = parseInt(UserModule.getCompany.vip_level.substr(0, 1));
    }
    this.isShowServicer = checkPermissionCompany(UserModule.getCompanyId,
      Type.SERVICE_COMPANY);
    // 如果是所有订单或者完结单默认一年报修日期
    if (this.stage === OrderStage.COMPLETED || this.stage === OrderStage.ALL) {
      // let y = new Date().getFullYear();
      // let flag = y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0);
      // if (flag) {
      //   this.yyyy = 366;
      // }
      // this.$set(this.orderForm, 'dateTimeRange', [parseTime(new Date().getTime() - 1000 * 60 * 60 * 24 * (this.yyyy - 1), '{y}-{m}-{d}'), parseTime(new Date(), '{y}-{m}-{d}')]);
      const oneyaerAgoTime = dayjs().subtract(1, 'year').hour(0).minute(0).second(0).valueOf();
      this.$set(
        this.orderForm,
        'dateTimeRange',
        [oneyaerAgoTime, new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()]
      )
    }
    if (this.stage === OrderStage.COMPLETED) {
      this.isShowWorkOrderNum = true;
    }

    this.searchKey = 'lsjl_search' + this.$route.path;
    let index = this.searchKey.lastIndexOf('/');
    if (index > 0) {
      this.searchKey = this.searchKey.substr(0, index);
    }
    if (localStorage.getItem(this.searchKey)) {
      let local: any = localStorage.getItem(this.searchKey);
      let localParse = JSON.parse(local);
      for (let p = 0; p < localParse.length; p++) {
        localParse[p].fields = '';
        localParse[p].isClearable = true;
      }
      if (this.stage === 5 || this.stage === 0) {
        for (let p = 0; p < localParse.length; p++) {
          if (localParse[p].id === '1') {
  
            const oneyaerAgoTime = dayjs().subtract(1, 'year').hour(0).minute(0).second(0).valueOf();
            localParse[p].fields = [oneyaerAgoTime, new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()];
            localParse[p].isClearable = false;
          }
          break;
        }
      }
      this.searchArray = localParse;
    } else {
      this.searchArray = [
        { fields: this.orderForm.dateTimeRange, name: '报修日期', id: '1', checked: true, show: true, isClearable: this.stage !== 5 && this.stage !== 0 },
        { fields: this.orderForm.appointmentTime, name: '预约时间', id: '2', checked: true, show: this.stage === 0 },
        { fields: this.orderForm.number, name: '订单号', id: '3', checked: true, show: true },
        { fields: this.orderForm.numberWork, name: '工单号', id: '4', checked: true, show: this.isShowWorkOrderNum },
        { fields: this.orderForm.person, name: '联系人', id: '5', checked: true, show: true },
        { fields: this.orderForm.servicer, name: '服务方', id: '6', checked: true, show: this.isShowServicer },
        { fields: this.orderForm.armedState, name: '任务状态', id: '7', checked: true, show: this.searchTaskStateVisibility },
        { fields: this.orderForm.customerDept, name: '报修部门', id: '8', checked: true, show: this.all },
        { fields: this.orderForm.address, name: '地址', id: '9', checked: true, show: this.all },
        { fields: this.orderForm.faultPhenomenon, name: '故障现象', id: '10', checked: true, show: this.all && this.vipLev === 2 }
      ];
    }
    this.showSearchArray = this.searchArray.filter((v: any) => {
      return v.show === true;
    });

  }

  private handleSearch() {
    let temp:any = [];
    if (this.orderForm.appointmentTime && this.orderForm.appointmentTime.length > 0) {
      this.orderForm.appointmentTime.map(function(item:any) {
        temp.push(item.toString().substring(0, 10));
      });
    }
    const params = {
      order_num: this.orderForm.number,
      // 要求时间为秒
      start_time: this.orderForm.dateTimeRange ? Math.floor(this.orderForm.dateTimeRange[0] / 1000) : '',
      end_time: this.orderForm.dateTimeRange ?  Math.floor(this.orderForm.dateTimeRange[1] / 1000) + 86400: '',
      name: this.orderForm.person,
      servicer_company_id: this.orderForm.servicer,
      armed_state: this.orderForm.armedState,
      work_order_num: this.orderForm.numberWork,
      appointment_timestamp: (temp && temp.length) > 0 ? JSON.stringify(temp) : '',
      customer_dept_id: this.orderForm.customerDept.id ? this.orderForm.customerDept.id : '',
      address: this.orderForm.address,
      fault_phenomenon_id: this.orderForm.faultPhenomenon.id ? this.orderForm.faultPhenomenon.id : '' // 先定只有内报
    };
    console.log(params)
    if (this.stage === 5 || this.stage === 0) {

      if (this.orderForm && this.orderForm!=null  && Number(params.end_time) -  Number(params.start_time)  > 60 * 60 * 24 * this.yyyy ) {
        this.$notify({
          title: '提示',
          message: '开始时间和结束时间范围不超过一年',
          offset: 100,
          type: 'error'
        });
        return;
      }
    }
    // 用eventBus来进行兄弟间的组建传值，params为要传递的参数
    eventBus.$emit('orderSearch', params);
  }

  private handleClear() {
    this.orderForm = {
      number: '',
      person: '',
      servicer: '',
      armedState: '',
      customerDept: {},
      faultPhenomenon: {}
    };
    if (this.searchArray) {
      for (let v = 0; v < this.searchArray.length; v++) {
        if (!((this.stage === 5 || this.stage === 0) && this.searchArray[v].id === '1')) {
          this.searchArray[v].fields = '';
        } else {
          const oneyaerAgoTime = dayjs().subtract(1, 'year').hour(0).minute(0).second(0).valueOf();
          this.searchArray[v].fields = [oneyaerAgoTime, new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()]
        }
      }
    }

    if (this.stage === 5 || this.stage === 0) {
      const oneyaerAgoTime = dayjs().subtract(1, 'year').hour(0).minute(0).second(0).valueOf();
      this.$set(
        this.orderForm,
        'dateTimeRange',
        [oneyaerAgoTime, new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()]
      )
    } else {
      this.$set(this.orderForm, 'dateTimeRange', '');
    }
    eventBus.$emit('orderSearch');
  }

  private orderFormReceive(val: any, keyup: any) {
    switch (val.id) {
      case '1':
        this.orderForm.dateTimeRange = val.fields;
        break;
      case '2':
        this.orderForm.appointmentTime = val.fields;
        break;
      case '3':
        this.orderForm.number = val.fields;
        break;
      case '4':
        this.orderForm.numberWork = val.fields;
        break;
      case '5':
        this.orderForm.person = val.fields;
        break;
      case '6':
        this.orderForm.servicer = val.fields;
        break;
      case '7':
        this.orderForm.armedState = val.fields;
        break;
      case '8':
        this.orderForm.customerDept = val.fields;
        break;
      case '9':
        this.orderForm.address = val.fields;
        break;
      case '10':
        this.orderForm.faultPhenomenon = val.fields;
        break;
    }
    if (keyup) {
      this.handleSearch();
    }
  }

  toggleHandle() {
    this.isToggle = !this.isToggle;
  }
  confirmHandle() {
    let setItem: any = [];
    setItem = this.searchArray.filter((t: any) =>
      (!this.checkList.some((ele: any) => ele.id === t.id)) && t.show
    );
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < setItem.length; i++) {
        if (this.searchArray[m].id === setItem[i].id) {
          this.searchArray[m].checked = false; // 设置取消
        }
      }
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.searchArray[m].id === this.checkList[i].id) {
          this.searchArray[m].checked = true; // 设置选中
        }
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }

  settingLocal() {
    localStorage.setItem(this.searchKey, JSON.stringify(this.searchArray));
  }
}
